import { ERROR_CODES } from '@/api/utils/dict'

const yaLoginError = 'При входе через Яндекс мы не получили твой email. Давай добавим его, чтобы продолжить.'
const vkLoginError = 'При входе через VK мы не получили твой email. Давай добавим его, чтобы продолжить.'
const googleLoginError = 'При входе через Google мы не получили твой email. Давай добавим его, чтобы продолжить.'

export const dict: { [k: string]: string | undefined } = {
  [ERROR_CODES.unknownError]: 'Что-то пошло не так. Попробуй ещё раз.',
  [ERROR_CODES.aiEmptyAnswer]: 'Не получилось ответить. Я вернула твой вопрос в поле ввода, попробуй отправить ещё раз.',
  [ERROR_CODES.userNotFound]: 'Аккаунт не найден. Проверь почту и попробуй снова.',
  [ERROR_CODES.userEmailAlreadyExists]: 'Этот email уже привязан к другому аккаунту. Попробуй войти с ним отдельно.',
  [ERROR_CODES.otpInvalidCode]: 'Похоже, код неверный. Попробуй ещё раз.',
  [ERROR_CODES.otpCodeNotFound]: 'Код не найден. Можно запросить новый.',
  [ERROR_CODES.otpCodeExpired]: 'Срок действия кода истёк. Отправим новый?',
  [ERROR_CODES.otpTooManyRequest]: 'Ты запрашивала код слишком часто. Попробуй снова через 10 секунд.',
  [ERROR_CODES.subscriptionNoActive]: 'Подписка сейчас не активна.',
  [ERROR_CODES.subscriptionNoPaymentId]: 'Не удалось найти данные по подписке.',
  [ERROR_CODES.discountNotAvailable]: 'Скидка уже недоступна. Обнови страницу и попробуй снова.',
  [ERROR_CODES.locationNotFound]: 'Место не найдено. Попробуй указать ближайший крупный населённый пункт.',
  [ERROR_CODES.birthDateRequired]: 'Укажи дату рождения.',
  [ERROR_CODES.freeMessagesLimit]: 'Ты достигла дневного лимита сообщений. Попробуй снова завтра.',
  [ERROR_CODES.missingPaymentId]: 'Похоже, эта страница была открыта без оформления оплаты. Вернись назад и попробуй снова.',
  [ERROR_CODES.nameNotValid]: 'Похоже, здесь написано больше, чем имя. Напиши только имя.',
  [ERROR_CODES.nameRequired]: 'Введи, пожалуйста, свое имя.',
  [ERROR_CODES.emailRequired]: 'Введи, пожалуйста, свой email.',
  [ERROR_CODES.dateNotValid]: 'Кажется, дата введена неправильно. Проверь, пожалуйста.',
  [ERROR_CODES.timeNotValid]: 'Кажется, время введено неправильно. Проверь, пожалуйста.',
  [ERROR_CODES.emailNotValid]: 'Кажется, email введен неправильно. Проверь, пожалуйста.',
  [ERROR_CODES.otpNotValid]: 'Кажется, код введен неправильно. Проверь, пожалуйста.',
  [ERROR_CODES.tooManyRequests]: 'Слишком много запросов. Попробуй снова через 30 секунд.',
  [ERROR_CODES.matrixYearSeasonNotFound]: 'Сезон не найден.',
  [ERROR_CODES.adminNatalChartNotFound]: 'Натальная карта не найдена.',
  [ERROR_CODES.bonusAlreadyGranted]: 'Спасибо, что снова поделился ответами 💜 Бонус в 10 бесплатных сообщений начисляется один раз и уже был получен ранее.',

  [ERROR_CODES.yaCodeMustBeDefined]: yaLoginError,
  [ERROR_CODES.yaTokenExchangeFailed]: yaLoginError,
  [ERROR_CODES.yaUserFetchFailed]: yaLoginError,
  [ERROR_CODES.yaEmailNotDefined]: yaLoginError,
  [ERROR_CODES.yaStateNotDefined]: yaLoginError,
  [ERROR_CODES.yaStateNotFounded]: yaLoginError,
  [ERROR_CODES.yaAuthFailed]: yaLoginError,

  [ERROR_CODES.vkStateNotDefined]: vkLoginError,
  [ERROR_CODES.vkStateNotFounded]: vkLoginError,
  [ERROR_CODES.vkCodeNotDefined]: vkLoginError,
  [ERROR_CODES.vkTokenExchangeFailed]: vkLoginError,
  [ERROR_CODES.vkEmailNotDefined]: vkLoginError,
  [ERROR_CODES.vkUserFetchFailed]: vkLoginError,
  [ERROR_CODES.vkAuthFailed]: vkLoginError,

  [ERROR_CODES.googleCodeMustBeDefined]: googleLoginError,
  [ERROR_CODES.googleTokenExchangeFailed]: googleLoginError,
  [ERROR_CODES.googleUserFetchFailed]: googleLoginError,
  [ERROR_CODES.googleEmailNotDefined]: googleLoginError,
  [ERROR_CODES.googleStateNotDefined]: googleLoginError,
  [ERROR_CODES.googleStateNotFounded]: googleLoginError,
  [ERROR_CODES.googleAuthFailed]: googleLoginError,
}
